import { recipeMarker, type SurfaceRecipeId, assertId } from '@vjal/screen-ir'

export type ActionDomProps = {
  'data-vjal-action': string
}

export type RecipeDomProps = {
  'data-vjal-recipe': string
}

export type ProTableDomProps = {
  'data-vjal-pro-table': string
  'data-vjal-recipe': string
}

/** Stable DOM marker for walk/mutation drivers. */
export function actionProps(id: string): ActionDomProps {
  assertId('action', id)
  return { 'data-vjal-action': id }
}

export function recipeProps(recipe: SurfaceRecipeId): RecipeDomProps {
  return { 'data-vjal-recipe': recipeMarker(recipe) }
}

export function proTableDataAttrs(): ProTableDomProps {
  return {
    'data-vjal-pro-table': '',
    'data-vjal-recipe': recipeMarker('ProTable-1'),
  }
}
